import { useQuery } from "@tanstack/react-query";
import { getCustomer } from "./customersApi";

export const useCustomerWithId = (customerId: string | undefined) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["customers", customerId],
    queryFn: ({ signal }) => getCustomer(customerId!, signal),
    enabled: !!customerId,
  });
  return { customer: data, isLoading, isError };
};
